/* eslint-disable camelcase */
import React from 'react';
import memoize from 'memoize-one';

import { ApproveRejectActions, DatatableEmployeeName } from '../../../components';

const columns = memoize(clickHandler => [
  {
    name: 'NOMBRE DEL TRABAJADOR',
    selector: 'employee',
    cell: item => <DatatableEmployeeName item={item.employee} onClick={() => clickHandler(item, 'show')} />,
    sortable: true,
    grow: '2'
  },
  {
    name: 'Cargo',
    selector: 'job_title',
    sortable: true,
    center: true,
    grow: '2'
  },
  {
    name: 'Fecha de Solicitud',
    selector: 'created_at',
    sortable: true,
    grow: '1'
  },
  {
    name: 'Fecha Inicio',
    selector: 'start_date',
    sortable: true,
    grow: '1'
  },
  {
    name: 'Fecha Término',
    selector: 'end_date',
    sortable: true,
    grow: '1'
  },
  {
    name: 'Fecha Retorno',
    selector: 'reincorporation_date',
    sortable: true,
    grow: '1'
  },
  {
    name: 'Días',
    selector: 'days_taken',
    sortable: true,
    center: true
  },
  {
    name: 'Horas Extras',
    selector: 'extra_hours_taken',
    sortable: true,
    center: true
  },
  {
    name: 'ESTADO',
    selector: 'translated_status',
    sortable: true,
    grow: '1',
    center: true
  },
  {
    name: 'ACCIONES',
    cell: item => (
      <ApproveRejectActions
        resource="OvertimeCompensationRequest"
        item={item}
        clickHandler={clickHandler}
        approveText={item.request_reviewer_signature ? 'Firmar' : 'Aprobar'}
        withDestroy
      />
    ),
    ignoreRowClick: true,
    allowOverflow: false,
    right: true,
    minWidth: '100px'
  }
]);

export default columns;
